function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataverifieractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.490196%,25.490196%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 24 0.300781 C 10.898438 0.300781 0.300781 10.898438 0.300781 24 C 0.300781 37.101562 10.898438 47.699219 24 47.699219 C 37.101562 47.699219 47.699219 37 47.699219 24 C 47.699219 11 37.101562 0.398438 24 0.300781 Z M 35.101562 19.5 L 23.601562 31.199219 C 23.199219 31.601562 22.699219 31.800781 22.199219 31.800781 C 21.699219 31.800781 21.199219 31.601562 20.898438 31.300781 L 14.398438 25.398438 C 13.601562 24.699219 13.5 23.398438 14.300781 22.601562 C 15 21.800781 16.300781 21.699219 17.101562 22.5 L 22.199219 27.101562 L 32.398438 16.699219 C 33.199219 15.898438 34.398438 15.898438 35.199219 16.699219 C 35.898438 17.398438 35.898438 18.699219 35.101562 19.5 Z M 35.101562 19.5 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataverifieractive);
export default __webpack_public_path__ + "static/media/data verifier active.2d00f38ef6af34b164524863c09ff060.svg";
export { ForwardRef as ReactComponent };